import { UploadTypeArray } from "./typing";

export const NO_WHEEL = "nowheel";

export const uploadTypes: UploadTypeArray = [
  "uploadFile",
  "uploadImage",
  "baseVideo",
  "unStructured",
  "table",
  "pdfFile",
  "audio",
  "html",
];
